import React from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import axios from "axios";
import "../stylesheets/resource.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faHistory,
	faCheckCircle,
	faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link, Redirect } from "react-router-dom";
import { UserConsumer } from "../../UserContext";
import {
	AllocateTeam,
	tableStyle,
	dateCol,
	ProjectStatus,
} from "../ticketModule/variables/ListingVariables";
import Edit from "../../images/edit.svg";
import { Project_APIs } from "./Project_APIs";
import Header from "../timesheetModule/Header";
import { Table } from "../../components/CustomPaginations";
import { AlertPopups } from "../../components/AlertPopups";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { Routes } from "../../configurations/config";

let token,
	empDesignation = null;
class ProjectListing extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isLoaded: false,
			items: [],
			toggledClearRows: false,
			allocateTo: [],
			projectDetails: {},
			tableLoader: false,
			showBtnLoader: false,
			currentPage: 1,
			pagerData: this.state?.pagerData ? [] : null,
			numberOfItemsPerPage: GlobalPaginationSize.defaultPaginationSize,
			pageNum: 1,
			sortBy: {
				dataField: "projectStatus",
				order: "desc",
			},
		};
		this.input = React.createRef();
	}
	defaultSorted = [
		{
			dataField: "projectStatus",
			order: "desc",
		},
	];
	getColumns = () => {
		return [
			{
				dataField: "projectName",
				text: "Project Name",
				sort: true,
				formatter: this.nameFormatter,
				headerStyle: {
					width: "14%",
				},
			},
			{
				dataField: "DevOpsName",
				text: "DevOps Name",
				sort: true,
				formatter: (cell, row) => {
					return row.devopsProjectName === null
						? "N/A"
						: row.devopsProjectName;
				},
				headerStyle: {
					width: "14%",
				},
			},
			{
				dataField: "projectType",
				text: "Project Type",
				sort: true,
				formatter: (cel, row) => {
					return row.projectType === null ? "N/A" : row.projectType;
				},
				headerStyle: {
					width: "14%",
				},
			},
			{
				dataField: "supervisorName",
				text: "Supervisor",
				sort: true,
				formatter: (cell, row) => {
					return row.supervisorName === null
						? "N/A"
						: row.supervisorName;
				},
				headerStyle: {
					width: "18%",
				},
			},
			{
				dataField: "allocateTo",
				text: "Team",
				formatter: AllocateTeam,
				filterValue: (cell, row) => {
					const allocateTeam = row.map(
						(allocateTo) => allocateTo.name
					);
					return allocateTeam;
				},
			},
			{
				dataField: "projectStatus",
				text: "Status",
				sort: true,
				formatter: ProjectStatus,
				headerStyle: {
					width: "11%",
				},
			},
			{
				dataField: "createdAt",
				text: "Allocate Date",
				sort: true,
				formatter: dateCol,
				headerStyle: {
					width: "15%",
				},
			},

			{
				dataField: "link",
				text: "Action",
				align: "center",
				events: {
					onClick: (e) => {
						e.stopPropagation(); // To stop navigation to detail screen
					},
				},
				formatter: (cell, row, e) => {
					return (
						<div className="d-inline-flex">
							<Link
								to={{
									pathname: `${Routes.UpdateProject}/${row.projectId}`,
									state: {
										currentPage: this.state.currentPage,
										redirectUrl: Routes.ProjectListing,
										projectName: row.projectName,
									},
								}}
							>
								<img
									title="Edit"
									className="hoverEffect"
									style={{ height: "20px", width: "20px" }}
									src={Edit}
									alt="ohSnap"
								/>
							</Link>
							<button
								className="toggleBtn"
								onClick={(e) =>
									this.statusHandler(
										row.projectId,
										row.projectStatus,
										e
									)
								}
							>
								{row.projectStatus === 1 ? (
									<FontAwesomeIcon
										title="Inactive"
										style={{
											width: "18px",
											height: "18px",
											marginLeft: "9px",
										}}
										className="inActiveToggle"
										icon={faMinusCircle}
										size="1x"
									/>
								) : row.projectStatus === 0 ? (
									<FontAwesomeIcon
										title="Active"
										style={{
											width: "18px",
											height: "18px",
											marginLeft: "9px",
										}}
										className="activeToggle"
										icon={faCheckCircle}
										size="1x"
									/>
								) : (
									<></>
								)}
							</button>
							<Link
								to={{
									pathname: `${Routes.ProjectHistory}/${row.projectId}`,
									state: {
										currentPage: this.state.currentPage,
										redirectUrl: Routes.ProjectListing,
										projectName: row.projectName,
									},
								}}
							>
								<button className="btnStyle">
									<FontAwesomeIcon
										title="History"
										style={{
											color: "grey",
											width: "18px",
											height: "18px",
											marginLeft: "2px",
										}}
										className="hoverEffect"
										id="edit"
										icon={faHistory}
										size="1x"
									/>
								</button>
							</Link>
						</div>
					);
				},
				headerStyle: {
					width: "12%",
					textAlign: "center",
				},
			},
		];
	};
	SearchBar = () => {
		const handleClick = (e) => {
			const value = this.input.value;
			this.setState({
				input: value,
			});
			const headers = {
				Authorization: `Bearer ${token}`,
			};
			if (value === "") {
				this.setState({ tableLoader: true }, () => {
					axios
						.get(
							`${Project_APIs.GetAllProjects_API}${1}&PageSize=${
								this.state.numberOfItemsPerPage
							}&SortBy=${this.state.sortBy.dataField}_${
								this.state.sortBy.order
							}`,
							{ headers: headers }
						)
						.then((res) => {
							const projects = [];
							const teams = [];
							res.data.forEach(
								({ allocateTo, projectDetails }) => {
									projectDetails.allocateTo = allocateTo;
									projects.push(projectDetails);
									teams.push(projects);
								}
							);
							this.setState({
								pageNum: 1,
								items: projects,
								tableLoader: false,
								pagerData: JSON.parse(
									res.headers["x-pagination"]
								),
							});
						});
				});
			} else {
				this.setState({ tableLoader: true }, () => {
					axios
						.get(
							`${Project_APIs.GetAllProjects_API}${1}&PageSize=${
								this.state.numberOfItemsPerPage
							}&SortBy=${this.state.sortBy.dataField}_${
								this.state.sortBy.order
							}&SearchTerm=${value}`,
							{ headers: headers }
						)
						.then((res) => {
							const projects = [];
							const teams = [];
							res.data.forEach(
								({ allocateTo, projectDetails }) => {
									projectDetails.allocateTo = allocateTo;
									projects.push(projectDetails);
									teams.push(projects);
								}
							);
							this.setState({
								pageNum: 1,
								items: projects,
								tableLoader: false,
								pagerData: JSON.parse(
									res.headers["x-pagination"]
								),
							});
						});
				});
			}
		};
		return (
			<div className="col-lg-2 pr-0 mb-2">
				<input
					className="form-control resourceTickets-SearchBar"
					ref={(n) => (this.input = n)}
					type="text"
					onChange={handleClick}
					onFocus={() => this.setState({ currentPage: 1 })}
					placeholder="Search"
				/>
			</div>
		);
	};
	static getDerivedStateFromProps(nextProps, prevState) {
		return {
			currentPage:
				nextProps.history &&
				nextProps.history.location &&
				nextProps.history.location.state
					? nextProps.history.location.state.currentPage
					: prevState.currentPage,
		};
	}
	componentDidMount() {
		const { history } = this.props;
		history && history.replace();
		this.setState({
			numberOfItemsPerPage: getPaginationSizeOnRole(empDesignation),
		});

		this.populateProjects();
	}
	populateProjects = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ tableLoader: true }, () => {
			axios
				.get(
					`${Project_APIs.GetAllProjects_API}${
						this.state.pageNum
					}&PageSize=${this.state.numberOfItemsPerPage}${
						this.state.sortBy
							? "&SortBy=" +
							  this.state.sortBy.dataField +
							  "_" +
							  this.state.sortBy.order
							: ""
					}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					const projects = [];
					const teams = [];
					res.data.forEach(({ allocateTo, projectDetails }) => {
						projectDetails.allocateTo = allocateTo;
						projects.push(projectDetails);
						teams.push(projects);
					});
					this.setState({
						items: projects,
						tableLoader: !this.state.tableLoader,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				});
		});
	};
	statusHandler = (projectId, projectStatus) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		AlertPopups.confirmBox
			.fire({
				text: "Change Project Status?",
			})

			.then((result) => {
				if (result.value) {
					let dataPassed = {
						projectId: projectId,
						status:
							projectStatus === 0
								? 1
								: projectStatus === 1
								? 0
								: null,
					};
					axios
						.put(
							`${Project_APIs.ToggleActiveInactive_API}`,
							dataPassed,
							{
								headers: headers,
							}
						)
						.then((res) => {
							res.status === 200 && this.populateProjects();
							AlertPopups.successAlert.fire({
								text:
									projectStatus === 1 ? "Inactive" : "Active",
							});
						});
				}
			});
	};

	nameFormatter(cell, row, trimmedString) {
		const length = 15;
		const string = row?.projectName;
		trimmedString = string?.substring(0, length);
		return trimmedString;
	}

	receiveData = (PageSize) => {
		axios
			.get(
				`${
					Project_APIs.GetAllProjects_API
				}${1}&PageSize=${PageSize}&SortBy=${
					this.state.sortBy.dataField
				}_${this.state.sortBy.order}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				const projects = [];
				const teams = [];
				res.data.forEach(({ allocateTo, projectDetails }) => {
					projectDetails.allocateTo = allocateTo;
					projects.push(projectDetails);
					teams.push(projects);
				});
				if (res.status === 200) {
					this.setState({
						pageNum: 1,
						numberOfItemsPerPage: PageSize,
						pagerData: JSON.parse(res.headers["x-pagination"]),
						items: projects,
					});
				}
			});
	};
	handleTableChange = (type, { page, sortOrder, sortField }) => {
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${Project_APIs.GetAllProjects_API}${page}&PageSize=${this.state.numberOfItemsPerPage}&SortBy=${sortField}_${sortOrder}`;
			getData = true;
			this.setState({
				sortBy: { dataField: sortField, order: sortOrder },
			});
		} else if (type === "pagination") {
			apiURL = `${Project_APIs.GetAllProjects_API}${page}&PageSize=${this.state.numberOfItemsPerPage}&SortBy=${this.state.sortBy.dataField}_${this.state.sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					const projects = [];
					const teams = [];
					res.data.forEach(({ allocateTo, projectDetails }) => {
						projectDetails.allocateTo = allocateTo;
						projects.push(projectDetails);
						teams.push(projects);
					});
					if (res.status === 200) {
						this.setState({
							pageNum: page,
							pagerData: JSON.parse(res.headers["x-pagination"]),
							items: projects,
						});
					}
				});
		}
	};
	exportToExcel = () => {
		this.setState({
			showBtnLoader: true,
		});
		axios
			.get(`${Project_APIs.ExportToExcel}`, {
				headers: { Authorization: `Bearer ${token}` },
				responseType: "blob",
			})
			.then(({ data }) => {
				const url = window.URL.createObjectURL(new Blob([data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "TEOProjects.xlsx");
				document.body.appendChild(link);
				link.click();
				this.setState({
					showBtnLoader: false,
				});
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
				this.setState({
					showBtnLoader: false,
				});
			});
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					empDesignation = userDetails.designation;
					return userDetails.designation.toString() === "4" ||
						userDetails.id.toString() === "180" ||
						userDetails.id.toString() === "786" ||
						userDetails.id.toString() === "269" ? (
						<div className="container-fluid pl-4 pr-4">
							<Header title="All Projects" />
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: this.state.pagerData
										? this.state.pagerData.TotalCount
										: 0,
									page: this.state.pageNum,
									sizePerPage:
										this.state.numberOfItemsPerPage,
									paginationSize:
										this.state.numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											columns={this.getColumns()}
											items={this.state.items}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												this.handleTableChange
											}
											tableLoader={this.state.tableLoader}
											loading={this.state.tableLoader}
											SearchBar={this.SearchBar}
											inputValue={this.input.value}
											exportExcelButton={true}
											exportToExcelClick={
												this.exportToExcel
											}
											showBtnLoader={
												this.state.showBtnLoader
											}
											disabled={!this.state.items.length}
											projectList={true}
											keyField="projectId"
											pagerData={this.state?.pagerData}
											receiveData={(PageSize) => {
												this.receiveData(PageSize);
											}}
											defaultSorted={this.defaultSorted}
											rowEvents={{
												onClick: (e, row) => {
													this.props.history.push({
														pathname: `${Routes.UpdateProject}/${row.projectId}`,
														state: {
															currentPage:
																this.state
																	.currentPage,
															redirectUrl:
																Routes.ProjectListing,
															projectName:
																row.projectName,
														},
													});
												},
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}

export default ProjectListing;
